// Homepage case-study strip (EN + FR): heading and labels, and which case studies show, in order.
// "items" (keys from src/data/caseStudies.js) is used for both languages, so it is only on the
// English side. Each card's title and summary come from the case study itself.
const CASES_DEFAULTS = {
  "en": {
    "eyebrow": "Field experience",
    "title": "Recent case studies",
    "intro": "Operational playbooks: the problem, the approach, the measured outcome.",
    "toggleLabel": "Show case studies",
    "readLabel": "Read the playbook",
    "buttonLabel": "See all case studies",
    "items": [
      { "caseStudyKey": "festival-25000-attendees" },
      { "caseStudyKey": "distribution-centre-cargo-theft" },
      { "caseStudyKey": "retail-chain-lp-rollout" }
    ]
  },
  "fr": {
    "eyebrow": "Expérience sur le terrain",
    "title": "Études de cas récentes",
    "intro": "Playbooks opérationnels : le problème, l'approche, le résultat mesuré.",
    "toggleLabel": "Voir les études de cas",
    "readLabel": "Lire le playbook",
    "buttonLabel": "Voir toutes les études de cas"
  }
};

export default CASES_DEFAULTS;
